import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {UpscaleImagesParams} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {type UpscaleImageParams, fetchUpscaledImages} from './requests'
import {ERRORS} from '../constants'

export const upscaleImages = async (
    {serverFacade}: Pick<EnvironmentContext, 'serverFacade'>,
    createExtArgs: CreateExtArgs,
    {componentPointers, userRequestInfo, onSuccess, onError}: UpscaleImagesParams
): Promise<void> => {
    return generateAndInjectImages<UpscaleImageParams>(
        createExtArgs,
        serverFacade,
        componentPointers,
        (_key, url) => ({
            imageUrl: url
        }),
        fetchUpscaledImages,
        {userRequestInfo, onSuccess, onError, caller: 'upscaleImages', errorType: ERRORS.IMAGES.UPSCALE_IMAGES}
    )
}
